/* Copyright (c) 2021 Magnusson Institute, All Rights Reserved */

/* If you're able to read this, congratulations, that's intentional,
   it is early code, under transparent development, there is still
   a long backlog of things to do and bugs to fix, and yes we do intend
   to publish both client and server code as open source */

import React from 'react'
import MiChat from './containers/MiChat/MiChat'
import './App.css'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { messages } from './locales/en/messages'
import { en, cs } from 'make-plural/plurals'

i18n.loadLocaleData({
  en: { plurals: en },
})
i18n.load('en', messages)
i18n.activate('en')


const App: React.FC = () => {


  return (
    <I18nProvider i18n={i18n}>
      <MiChat />
    </I18nProvider>
  )
}

export default App
